import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { v4 } from 'uuid'
import TableComponent from '../../../components/Common/TableComponent'
import RichText from '../../../components/RichEditor/RichText'
import { compare } from './diff_compare_object'
import { TableActionWrapper } from '../../ConnectedCommitteeDocumentOutgoingDocPage/ConnectedCommitteeDocumentOutgoingDocPageStyled'
import { Table } from 'antd'

const DiffTable = props => {
  const { type, dataBefore, dataAfter, riskDetail, historyList } = props
  const [diffList, setDiffList] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const diff = await compare(type, JSON.parse(dataBefore), JSON.parse(dataAfter), riskDetail);
      setDiffList(diff);
    };
    fetchData();
  }, [type, historyList, dataBefore, dataAfter, riskDetail]);

  const columns = [
    {
      title: 'Trường dữ liệu',
      width: 150,
      render: record => <RichText htmlText={record.field}></RichText>,
    },
    {
      title: 'Trước thay đổi',
      width: 500,
      render: record => (
        <div style={{ maxWidth: '500px', maxHeight: '100%', overflowX: 'auto', whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
          <RichText htmlText={record.fieldValueBefore}></RichText>
        </div>
      ),
    },
    {
      title: 'Sau thay đổi',
      width: 500,
      render: record => (
        <div style={{ maxWidth: '500px', maxHeight: '100%', overflowX: 'auto', whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
          <RichText htmlText={record.fieldValueAfter}></RichText>
        </div>
      )
    },
  ]

  return (
    <div>
      <Table
        rowKey={() => v4()}
        dataSource={diffList}
        columns={columns}
        pagination={false}
      />
    </div>
  )
}

DiffTable.propTypes = {
  dataBefore: PropTypes.string,
  dataAfter: PropTypes.string,
  type: PropTypes.string,
}

export default DiffTable
